import { filter, map } from 'lodash'
import moment from 'moment'
import bus from '@/utils/eventBus'
moment.locale('pt')

const prepareLocks = schedules => {
  return filter(schedules, {lock: true})
}

const prepareSave = schedules => {
  const data = map(prepareLocks(schedules), schedule => {
    return {
      id: schedule.id
    }
  })

  return {
    schedules: data
  }
}

const prepareSchedule = schedule => {
  schedule.lock = false
  schedule.day = moment(schedule.date).format('dddd')
  schedule.time = moment(schedule.date).format('HH:mm')
  schedule.date = moment(schedule.date).format('DD/MM/YYYY')

  return {...schedule}
}

export default {
  // Excluindo dos os registro antes de ser publicado ainda no preview
  doDeleteAll (rule) {
    this.$http.get('v1/professional/agendas/rules/' + rule.id + '/schedule-delete')
      .then(({data}) => {
        // emitindo evento para ocultar botoes no form rule
        bus.$emit('cancel-on-preview', {show: true})
        bus.$emit('publishing-no-preview', {show: false})
        this.$emit('locked', true)
      })
  },
  // publicando regra, modificando para avaliabled
  doPublish (rule) {
    this.$http.put('/v1/professional/agendas/rules/' + rule.id + '/publish')
      .then(({data}) => {
        // emitindo evento para desabilitar botão salvar alterações apos publicar
        bus.$emit('published-on-preview', {show: true})
        this.$emit('locked', true)
      })
  },
  // Removendo horarios selecionado na pre visualização
  doRemoves () {
    const removes = prepareSave(this.schedules)
    this.$resource.put('', removes)
      .then(({data}) => {
        this.schedules = map(data.schedules, prepareSchedule)
        console.log(this.schedules)
        // this.$emit('locked', true)
      })
  },
  setSchedules () {
    this.schedules = map(this.data, prepareSchedule)
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/schedulings/preview/resources/methods.js